import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonGroupControlModule } from '@tablesready/button-group-control';
import { LoaderModule } from '@tablesready/common-ui';
import { CanvasComponent } from './canvas.component';
import { FloorplanSwitcherComponent } from './floorplan-switcher/floorplan-switcher.component';
import { FrontendScrollbarModule } from '@tablesready/frontend-scrollbar';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [
    CanvasComponent,
    FloorplanSwitcherComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonGroupControlModule,
    FrontendScrollbarModule,
    LoaderModule,
    FrontendIconsModule,
  ],
  exports: [
    CanvasComponent,
    FloorplanSwitcherComponent,
  ],
})
export class CanvasModule {}
